// lib/assets/preload.ts

type PreloadAsset = {
  href: string
  as: 'image' | 'font' | 'script' | 'style'
  type?: string
}

export const preloadAssets: Record<string, PreloadAsset[]> = {
  '/fr/landing/usages/immo': [
    { href: '/lb/all_real_estate.webp', as: 'image', type: 'image/webp' },
    { href: '/lb/notary_meet.webp', as: 'image', type: 'image/webp' },
    { href: '/lb/reassuring_env.webp', as: 'image', type: 'image/webp' },
    { href: '/lb/simple.webp', as: 'image', type: 'image/webp' },
    { href: '/lb/how-it-works-4steps.webp', as: 'image', type: 'image/webp' }
  ]
}
